export type TMqttTrigger = {
  type: "mqtt";
  device_id?: number;
  topic?: string;
};

export const defaultMqttTrigger: TMqttTrigger = {
  type: "mqtt",
};

export type TSunTrigger = {
  type: "sun";
  event: "sunrise" | "sunset";
  offset: string;
};

export const defaultSunTrigger: TSunTrigger = {
  type: "sun",
  event: "sunrise",
  offset: "+00:00",
};

export type TTimeTrigger = {
  type: "time";
  at: string;
  delta: string;
};

export const defaultTimeTrigger: TTimeTrigger = {
  type: "time",
  at: "12:30",
  delta: "00:00",
};
